module.exports = __webpack_public_path__ + "img/arachides.63a3f66a.svg";